import React from 'react';
import { useParams } from 'react-router-dom';
import ListeningAudio from '../components/Mock/ListeningAudio';

const ListeningAudioPage = () => {
  const { passageId } = useParams(); // ✅ get passageId from URL

  const jsonPath = `/data/mock1Listening${passageId}.json`;
  const nextRoute = `/lessonMock/mock1/listening/${passageId}/questions`;

  return (
    <ListeningAudio
      jsonPath={jsonPath}
      nextRoute={nextRoute}
    />
  );
};

export default ListeningAudioPage;
